import { rLog } from '~/scripts/lib/utils';
import Pagelet from '~/scripts/lib/Pagelet';

export default function() {
  rLog('Start streaming', window.R.ui.Stream);
  this.pagelet = new Pagelet();
  return new window.R.ui.Stream();
};
